import React from "react";
import { useObserver } from "../../../../CodesThatsGottaGoSomewhereElse";
import { Colors } from "../../../../ui";
import { MonthPicker } from "../../../../ui/MonthPopper";
import { PopoutWidget } from "../../../canvas/workspace/widgets/WidgetInterface";
import { Flexer } from "../../../dashboard/elements/LayoutElements";

export const FrameAddonMonthYearWidget = React.memo<{ widget: PopoutWidget }>(({ widget }) => {

    const date = useObserver(widget)?.value || new Date();
    const setDate = (date: Date) => widget.update({ value: date });

    return <Flexer color={Colors.text}>
        <MonthPicker mode="single" date={date} onChange={setDate} />
    </Flexer>;

});